import React from 'react';
import { Typography, Container, Box } from '@mui/material';
import { useTheme, useMediaQuery } from '@mui/material';

const Question = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Container
      className="mb-5 mt-5 text-[black]"
      style={{
        fontFamily: 'Roboto, sans-serif',
        padding: isMobile ? '0 16px' : '0 32px', // Adjust padding for mobile
      }}
    >
      <Box mb={4}>
        <Typography
          style={{
            fontSize: isMobile ? '18px' : '20px',
            fontWeight: 'bold',
          }}
        >
          Terms And Conditions
        </Typography>
      </Box>
      <Box mb={2}>
        <Typography
          style={{
            fontSize: isMobile ? '18px' : '20px',
            fontWeight: 'bold',
          }}
        >
          Loyalty Tier:
        </Typography>
      </Box>
      <Box mb={2}>
        <Typography style={{ fontSize: isMobile ? '14px' : '12px' }}>
          For <b>Silver</b> (Bought once in lifetime) Loyalty Tier has Cash benefits 1% of the sale
          (which can be used for next purchase).
        </Typography>
      </Box>
      <Box mb={2}>
        <Typography style={{ fontSize: isMobile ? '14px' : '12px' }}>
          For <b>Gold</b> (Bought more than once in lifetime) Loyalty Tier has Cash benefits 1.5% of the sale
          (which can be used for next purchase).
        </Typography>
      </Box>
      <Box mb={2}>
        <Typography style={{ fontSize: isMobile ? '14px' : '12px' }}>
          For Silver and Gold Loyalty Tier If the sale value of the lead booker goes above Rs.15 Lacs in a year,
          he/ she will be eligible for a 0.5% worth of points as additional kicker as <b>Bonus</b>.
        </Typography>
      </Box>
      <Box mb={2} mt={4}>
        <Typography
          style={{
            fontSize: isMobile ? '18px' : '20px',
            fontWeight: 'bold',
          }}
        >
          How do the Points work?
        </Typography>
      </Box>
      <Box mb={2}>
        <ul
          style={{
            marginLeft: '20px',
            listStyleType: 'disc',
            
          
            // paddingLeft: isMobile ? '10px' : '10px', // Adjust padding for mobile
            fontSize: isMobile ? '14px' : '16px', // Adjust font size for mobile
          }}
          className='text-center'
        >
          <li>
            <Typography>1 Point is equal to Rs.1</Typography>
          </li>
          <li>
            <Typography>Points will be credited into your account within 15 days from your travel start date</Typography>
          </li>
          <li>
            <Typography>100% of the points can be used to book your next holiday.</Typography>
          </li>
          <li>
            <Typography>
              A max of 20% of the points can be used to book a standalone flight with us in a single transaction max up to Rs.1500 for Intl. and Rs.1000 for Dom.
            </Typography>
          </li>
          <li>
            <Typography>
              A max of 30% of the points can be used to book a standalone hotel with us in a single transaction, max up to Rs.2000 for Dom. & Rs.4000 for Intl.
            </Typography>
          </li>
          <li>
            <Typography>
              The points in your account are valid for 18 months, after which they lapse and can’t be redeemed for next bookings.
            </Typography>
          </li>
          <li>
            <Typography>The points in your account are not transferable.</Typography>
          </li>
          <li>
            <Typography>
              Management reserves the right to withdraw points issued in case of any dispute that may arise or even sunset the program, in case of any unforeseen circumstances.
            </Typography>
          </li>
        </ul>
      </Box>
    </Container>
  );
}

export default Question;
